/**
 * 该路由下所有可能用到的方法
 */

export enum Methods {
  UserFollowerLoadMore = 'user-follower-load-more',
  UserFollowingLoadMore = 'user-following-load-more',
}
